
import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';


import LocationService from '../../../components/Services/LocationService';

import UserService from '../../../GlobalSetupComponents/Services/UserService';

import { backendUserList , roleIdProcurement} from '../../../GlobalSetupComponents/Enum/RoleEnum';
import CustomSelect from '../../../components/common/CustomSelect';

const ProspectPropertyFilter = ({ isOpen, onClose, onApplyFilters, currentFilters = {} }) => {
  // Filter states
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [selectedPropertySource, setSelectedPropertySource] = useState(null);
  const [selectedBackendUser, setSelectedBackendUser] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  
  const [propertyStageOptions, setPropertyStageOptions] = useState([]);

  const [locationData, setLocationData] = useState([]);
  const [propertySourceOptions , setPropertySourceOptions] = useState([])
  const [backendUserOptions , setBackendUserOptions] = useState([])

  // Sync with current filters from parent
  useEffect(() => {
    setSelectedLocation(currentFilters.location || null);
    setSelectedPropertyType(currentFilters.propertyType || null);
    setSelectedPropertySource(currentFilters.propertySource || null);
    setSelectedBackendUser(currentFilters.backendUser || null);
    setStartDate(currentFilters.startDate || '');
    setEndDate(currentFilters.endDate || '');
  }, [currentFilters]);



  const propertyStage = [
    {
        label : "Info Collection & Assignment",
        value : "Info Collection & Assignment",
    },
    {
        label : "Analysis",
        value : "Analysis",
    },
    {
        label : "Presentation Preparation",
        value : "Presentation Preparation",
    },
    {
        label : "Confirmed List",
        value : "Confirmed List",
    },
    {
        label : "Dropped",
        value : "Dropped",
    },
  ]




  // Fetch location data on component mount
  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const response = await LocationService.fetchLocation();
        const rawData = response.data || {};
        const formattedData = Array.isArray(rawData)
          ? rawData.map((item) => ({
              value: item.id,
              label: item.label || item.name || "",
            }))
          : Object.entries(rawData).map(([label, id]) => ({
              value: id,
              label: label,
            }));
        setLocationData(formattedData);
      } catch (error) {
        console.error("Error fetching location data:", error);
      }
    };

    if (isOpen) {
      fetchLocationData();
    }
  }, [isOpen]);

  const FetchPropertySourceOptions =  async() => {

   try{
            const body = { roleIds: roleIdProcurement };
        const response = await UserService.getUserRoleBasedNames(body);
        const data = response.data?.users || [];
        setPropertySourceOptions(data)
   }catch(error){
        console.error("Error fetching property source options:", error);
   }
  }

    // Fetch property source options on component mount

    const fetchBackendUserOptions = async () => {
        try {
            const body = { roleIds: backendUserList };
            const response = await UserService.getUserRoleBasedNames(body);
            const data = response.data?.users || [];
            setBackendUserOptions(data);
        } catch (error) {
            console.error("Error fetching backend user options:", error);
        }
    }

  useEffect(() => {
    fetchBackendUserOptions();
    FetchPropertySourceOptions();
  }, []);

  // Handle filter application
  const handleApplyFilters = () => {
    const filters = {
      location: selectedLocation,
      propertyType: selectedPropertyType,
      propertySource: selectedPropertySource,
      backendUser: selectedBackendUser,
      startDate: startDate,
      endDate: endDate,
    };

    console.log("Applied Filters:", filters);
    if (onApplyFilters) {
      onApplyFilters(filters);
    }
    onClose();
  };

  // Handle filter reset
  const handleClearFilters = () => {
    setSelectedLocation(null);
    setSelectedPropertyType(null);
    setSelectedPropertySource(null);
    setSelectedBackendUser(null);
    setStartDate('');
    setEndDate('');
    
    const emptyFilters = {
      location: null,
      propertyType: null,
      propertySource: null,
      backendUser: null,
      startDate: '',
      endDate: '',
    };

    if (onApplyFilters) {
      onApplyFilters(emptyFilters);
    }
    onClose();
  };

  // Get today's date for max date validation
  const today = new Date().toISOString().split('T')[0];

  return (
    <Sidebar
      header={
        <div className="flex items-center justify-between w-full">
          <span className="font-semibold text-lg text-customGreen">
            <h3>Property Filters</h3>
          </span>
        </div>
      }
      visible={isOpen}
      onHide={onClose}
      style={{ width: "400px" }}
      position="right"
      className="p-sidebar-md"
    >
      <div className="flex flex-col h-full justify-between gap-6 py-4">
        <div className="flex flex-col gap-4">
          <label className="text-xs text-gray-600">Location</label>
          {/* Location Filter */}
          <div className="space-y-2">
            <CustomSelect
              options={locationData}
              value={selectedLocation}
              onChange={setSelectedLocation}
              placeholder="Select Location"
              isClearable
              isSearchable
            />
          </div>

          {/* Property Stage Filter */}
          <div className="space-y-2">
            <label className="text-xs text-gray-600">Property Stage</label>
            <CustomSelect
              options={propertyStage}
              value={selectedPropertyType}
              onChange={setSelectedPropertyType}
              placeholder="Select Property Stage"
              isClearable
              isSearchable
            />
          </div>

          {/* Backend User Filter */}
          <div className="space-y-2">
            <label className="text-xs text-gray-600">Backend User</label>
            <CustomSelect
              options={backendUserOptions}
              value={selectedBackendUser}
              onChange={setSelectedBackendUser}
              placeholder="Select Backend User"
              isClearable
              isSearchable
            />
          </div>

          {/* Property Source Filter */}
          <div className="space-y-2">
            <label className="text-xs text-gray-600">Property Sourced By</label>
            <CustomSelect
              options={propertySourceOptions}
              value={selectedPropertySource}
              onChange={setSelectedPropertySource}
              placeholder="Select Property Source"
              isClearable
              isSearchable
            />
          </div>

        </div>

        {/* Footer Buttons */}
        <div className="flex flex-col gap-3 border-t pt-4">
          <button
            onClick={handleApplyFilters}
            className="w-full py-2 px-4 bg-customGreen text-white rounded-md font-medium hover:bg-green-600 transition-colors focus:outline-none focus:ring-2 focus:ring-customGreen focus:ring-offset-2"
          >
            Apply Filters
          </button>
          <button
            onClick={handleClearFilters}
            className="w-full py-2 px-4 bg-gray-100 text-gray-700 rounded-md font-medium hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
          >
            Clear All Filters
          </button>
        </div>
      </div>
    </Sidebar>
  );
};

export default ProspectPropertyFilter;

